import { render, staticRenderFns } from "./ZohoDocumentQuickView.vue?vue&type=template&id=ee96e29a&scoped=true"
import script from "./ZohoDocumentQuickView.vue?vue&type=script&lang=js"
export * from "./ZohoDocumentQuickView.vue?vue&type=script&lang=js"
import style0 from "./ZohoDocumentQuickView.vue?vue&type=style&index=0&id=ee96e29a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee96e29a",
  null
  
)

export default component.exports